export default {
    addAlert: ( state, payload ) => {
        state.alerts.push(payload);
    },
    removeAlert: ( state, payload ) => {
        state.alerts.splice(payload, 1);
    },
}